import React, { Fragment } from "react";
import { Grid, Box, Typography } from "@material-ui/core";
import IconAvailable from "./iconAvailable";
import IconUnavailable from "./iconUnavailable";
import StaffRating from "./StaffRating";
export default function StaffTable({
  timeHr,
  transformSchedule,
  submitSchedule,
  selectedDate,
}) {
  var border = {
    padding: "7px 10px",
    border: "1px solid var(--grey)",
    marginBottom: "0",
    color: "var(--text-color-2)",
    fontSize: "1.2rem",
    fontWeight: "600",
  };
  return (
    <Fragment>
      <Typography className="page-description">
        ③ 担当相談員を選択することができます。
        <span className="icon-desc-wrap">
          <IconAvailable />
          のみ、予約可能となります。
        </span>
        相談員指名のご要望がなければ、最上段の「指名なし」から時間帯を選択ください。
      </Typography>
      <Box className="staff-table" style={{ paddingTop: "50px" }}>
        <Grid container>
          <Grid item md={2} sm={2} xs={2}></Grid>
          <Grid item md={10} sm={10} xs={10}>
            <Grid container style={{ textAlign: "center" }}>
              {timeHr &&
                timeHr.map((time, id) => (
                  <Grid item key={id} xs={3}>
                    <Typography
                      style={{ ...border, backgroundColor: "#F0F2F2" }}
                      className="staff-table-time"
                    >
                      {time}時
                    </Typography>
                    <Grid container>
                      <Grid
                        item
                        xs={6}
                        style={{ ...border, backgroundColor: "#F0F2F2" }}
                        className="staff-table-time"
                      >
                        0分
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        style={{ ...border, backgroundColor: "#F0F2F2" }}
                        className="staff-table-time"
                      >
                        30分
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
            </Grid>
          </Grid>
        </Grid>
        {transformSchedule && (
          <>
            {transformSchedule.isAvailableAnyTime && (
              <Grid container className="agent-table">
                <Grid item md={2} sm={2} xs={2} className="agent-name">
                  <img
                    src={"/images/staff_free.png"}
                    alt=""
                    className="staff-free"
                  />
                  <Typography className="text-center">指名なし</Typography>
                </Grid>
                <Grid item md={10} sm={10} xs={10} container>
                  {Object.keys(transformSchedule.noAssignSchedules).map(
                    (key, id) => {
                      var isAvailable =
                        transformSchedule.noAssignSchedules[key];
                      var obj = {
                        type: "noAssign",
                        staffNickname: "指名なし",
                        imageUrl: "",
                      };
                      var time = key.replace("#", "-");
                      return (
                        <Grid
                          key={id}
                          item
                          style={{ width: "calc(100%/8)" }}
                          className={
                            isAvailable ? "agent-slot available" : "agent-slot"
                          }
                          onClick={(e) => {
                            submitSchedule(
                              isAvailable,
                              obj,
                              selectedDate,
                              time
                            );
                          }}
                        >
                          {isAvailable ? (
                            <IconAvailable />
                          ) : (
                            <IconUnavailable />
                          )}
                        </Grid>
                      );
                    }
                  )}
                </Grid>
              </Grid>
            )}
            {transformSchedule.staffSchedules.map((schedule, id) => (
              <Fragment key={id}>
                {schedule.isAvailableAnyTime && (
                  <Grid container className="agent-table" key={id}>
                    <Grid
                      item
                      md={2}
                      className="agent-name-wrapper"
                      sm={2}
                      xs={2}
                    >
                      <Box className="agent-name">
                        <img
                          src={
                            schedule.staffImageUrl
                              ? schedule.staffImageUrl
                              : "/images/staff_noimage.png"
                          }
                        />
                        <Typography>{schedule.staffNickname}</Typography>
                        <Typography>
                          {schedule.staffAge && schedule.staffAge + ", "}
                          {schedule.staffGender}
                        </Typography>
                        <StaffRating rating={schedule.averageScore} />
                        <Box className="agent-completion">
                          <Typography>
                            サポート数{" "}
                            {schedule.supportCompleteCount +
                              schedule.supportUnSolvedCount}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item md={10} sm={10} xs={10}>
                      <Grid container style={{ height: "100%" }}>
                        {Object.keys(schedule.schedules).map((key, id) => {
                          var isAvailable = schedule.schedules[key];
                          var obj = {
                            type: "withStaff",
                            staffAge: schedule.staffAge,
                            staffGender: schedule.staffGender,
                            staffImageUrl: schedule.staffImageUrl,
                            staffNickname: schedule.staffNickname,
                            averageScore: schedule.averageScore,
                            staffId: schedule.staffId,
                          };
                          var time = key.replace("#", "-");
                          return (
                            <Grid
                              item
                              style={{ width: "calc(100%/8)" }}
                              className={
                                isAvailable
                                  ? "agent-slot available"
                                  : "agent-slot"
                              }
                              key={id}
                              onClick={(e) =>
                                submitSchedule(
                                  isAvailable,
                                  obj,
                                  selectedDate,
                                  time
                                )
                              }
                            >
                              {isAvailable ? (
                                <IconAvailable />
                              ) : (
                                <IconUnavailable />
                              )}
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Fragment>
            ))}
          </>
        )}
      </Box>
    </Fragment>
  );
}
